export function getChildrenByName(parent, name) {
  return parent.getChildren(node => {
    return node.name() === name;
  });
}
